<mat-sidenav-container
  [class.closed-sidebar]="!isOpen()"
  [class.hidden-sidebar]="!isSidebarVisible()"
  (backdropClick)="closeSideNavigationBar()"
>
  <mat-sidenav
    #sidenav
    [mode]="sideNavMode()"
    [class.closed-sidebar]="!isOpen()"
    [disableClose]="true"
    class="column-fx-legacy"
  >
    <div class="sidenav-header">
      <a class="title" [routerLink]="['/parts-module/parts']">
        <img src="{{ iconPath }}" alt="" />
        <div class="userInfo" *ngIf="userInfo">
          <span class="profile">{{ userInfo.profile }}</span>
          <span class="username">{{ userInfo.username }}</span>
        </div>
      </a>
      <bci-burger
        [open]="isOpen()"
        (click)="toggleSideNavigationBar()"
      ></bci-burger>
    </div>
    <div class="sidenav-content">
      <bci-sidebar-nav-list
        [navItems]="sidebarLinks"
        *ngIf="sidebarLinks && sidebarLinks.length > 0"
      ></bci-sidebar-nav-list>

      <ng-content *ngIf="isOpen()" select="bci-sidebar-footer"></ng-content>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <bci-burger
      [open]="isOpen()"
      (click)="toggleSideNavigationBar()"
      *ngIf="isInMobileMode()"
    ></bci-burger>
    <div class="content-container row-fx-legacy">
      <div class="content-container-main column-fx-legacy grow-fx-legacy">
        <ng-content></ng-content>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
